var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 7.61 5.691 32.781 35.556"
    },
    viewBox: "7.61 5.691 32.781 35.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#b289e9}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.726 23.948 2.967 4.431 12.698-4.671-2.957-4.435-12.708 4.675z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.456 25.212v16.035l13.423-4.942V25.633l-10.208 3.756a.474.474 0 0 1-.555-.181l-2.66-3.996zM7.61 23.702l12.709 4.677 2.954-4.436-12.696-4.672-2.967 4.431z",
    className: "st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.09 36.305 13.424 4.942V25.281l-2.617 3.928a.472.472 0 0 1-.554.182L10.09 25.618v10.687zM11.754 18.703 24 23.211l12.256-4.508-6.133-2.256a7.402 7.402 0 0 1-6.124 3.207 7.404 7.404 0 0 1-6.124-3.206l-6.121 2.255z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24 5.691a6.519 6.519 0 0 0-6.511 6.511c0 3.59 2.92 6.511 6.511 6.511a6.518 6.518 0 0 0 6.511-6.511A6.52 6.52 0 0 0 24 5.691z",
    style: {
      fill: "#ad89e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.401 9.223-4.252 4.252-2.83-2.829a.474.474 0 0 0-.67.669l3.164 3.164a.474.474 0 0 0 .67 0l4.588-4.587c.186-.185.186-.485 0-.669s-.484-.184-.67 0z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstock);
export default __webpack_public_path__ + "static/media/instock.e5c5f0362bed29a867d335943f9e6f3b.svg";
export { ForwardRef as ReactComponent };